import { FC, useContext } from 'react';

import cn from 'classnames';

import { LocalizationContext } from 'localization';

import { AuthContext } from './constants';
import s from './PermissionHOC.module.scss';
import { PermissionKey } from './types';

// @ts-ignore TODO: incorrect types, check with react types version update (issue: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051)
export const PermissionHOC: FC<{
  permission: PermissionKey;
  className?: string;
}> = ({ children, permission, className }) => {
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const { t } = useContext(LocalizationContext);

  if (permissions?.has(permission)) {
    return children;
  }

  return (
    <div className={cn(s.placeholder, className)}>
      <span className={s.description}>{t('permission.error')}</span>
    </div>
  );
};
